import { useState, useEffect, useCallback } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useAuthContext } from "@/contexts/AuthContext";

export interface VibeFeedItem {
  id: string;
  item_type: "highlight" | "match_story" | "trending_arena" | "scheduled_arena";
  reference_id: string | null;
  title: string;
  description: string | null;
  thumbnail_url: string | null;
  video_url: string | null;
  user_ids: string[];
  engagement_count: number;
  created_at: string;
}

export const useVibeFeed = () => {
  const { user } = useAuthContext();
  const [feedItems, setFeedItems] = useState<VibeFeedItem[]>([]);
  const [loading, setLoading] = useState(true);

  const fetchFeedItems = useCallback(async () => {
    setLoading(true);
    
    // Fetch from database
    const { data, error } = await supabase
      .from("vibe_feed_items")
      .select("*")
      .order("created_at", { ascending: false })
      .limit(50);

    if (!error && data) {
      setFeedItems(data as VibeFeedItem[]);
    } else {
      // Return empty array if no data or error
      setFeedItems([]);
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    fetchFeedItems();
  }, [fetchFeedItems]);

  const likeItem = useCallback(async (itemId: string) => {
    setFeedItems(prev => prev.map(item => 
      item.id === itemId 
        ? { ...item, engagement_count: item.engagement_count + 1 }
        : item
    ));
  }, []);

  return {
    feedItems,
    loading,
    likeItem,
    refetch: fetchFeedItems,
  };
};
